import SihaGetDocumentByExternalIdRequestModelBase from '../_generated/modelBases/siha-get-document-by-external-id-request-model-base';

export default class SihaGetDocumentByExternalIdRequestModel extends SihaGetDocumentByExternalIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
